import { render, staticRenderFns } from "./receipt_view.vue?vue&type=template&id=24cf20be&scoped=true"
import script from "./receipt_view.vue?vue&type=script&lang=js"
export * from "./receipt_view.vue?vue&type=script&lang=js"
import style0 from "./receipt_view.vue?vue&type=style&index=0&id=24cf20be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cf20be",
  null
  
)

export default component.exports